import React, { useState } from 'react'
import { DayOfTheWeek, DaysOfTheWeekDiv } from './style'
import { CompanyInterface } from '..'

export interface companyComponentsProps {
  setCompany: React.Dispatch<React.SetStateAction<CompanyInterface>>
  company: CompanyInterface
}

const daysOfTheWeekArray = ['D','S','T','Q','Q','S','S']

const DisponibilityComponent:React.FC<companyComponentsProps> = (props) => {
  const { company, setCompany } = props
  
  const handleSetActivedDay = (dayNumber:number) => {
    if(!company.activedDays.includes(dayNumber)){
      return setCompany(prev => ({
        ...prev,
        activedDays:[...prev.activedDays, dayNumber]
      }))
    }
    setCompany(prev => ({
      ...prev,
      activedDays:prev.activedDays.filter(e => e !== dayNumber)
    }))

  }
  
  return(
    <DaysOfTheWeekDiv>
      {daysOfTheWeekArray.map((item, index) => 
        <DayOfTheWeek 
          onClick={() => handleSetActivedDay(index)}
          key={index}
          className={company.activedDays.includes(index) ? 'actived' : ''}
        >
          {item}
        </DayOfTheWeek>
      )}
    </DaysOfTheWeekDiv>
  )
}

export default DisponibilityComponent